export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  username: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  email: {
    value: null,
    maxlength: '70',
    required: true,
    state: null
  },
  empresaID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  grupoID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  funcionarioID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  telefoneCelular: {
    value: null,
    maxlength: '20',
    required: true,
    state: null
  },
  senha: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  confirmation: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/account/account-form.js